var _script, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _script || (_script = /*#__PURE__*/React.createElement("script", {
    xmlns: ""
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1437_8269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.9987 5.41667C13.157 5.41667 15.9737 7.19167 17.3487 10C15.9737 12.8083 13.1654 14.5833 9.9987 14.5833C6.83203 14.5833 4.0237 12.8083 2.6487 10C4.0237 7.19167 6.84036 5.41667 9.9987 5.41667ZM9.9987 3.75C5.83203 3.75 2.2737 6.34167 0.832031 10C2.2737 13.6583 5.83203 16.25 9.9987 16.25C14.1654 16.25 17.7237 13.6583 19.1654 10C17.7237 6.34167 14.1654 3.75 9.9987 3.75ZM9.9987 7.91667C11.1487 7.91667 12.082 8.85 12.082 10C12.082 11.15 11.1487 12.0833 9.9987 12.0833C8.8487 12.0833 7.91536 11.15 7.91536 10C7.91536 8.85 8.8487 7.91667 9.9987 7.91667ZM9.9987 6.25C7.93203 6.25 6.2487 7.93333 6.2487 10C6.2487 12.0667 7.93203 13.75 9.9987 13.75C12.0654 13.75 13.7487 12.0667 13.7487 10C13.7487 7.93333 12.0654 6.25 9.9987 6.25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1437_8269"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewWhite);
export default __webpack_public_path__ + "static/media/viewWhite.dea959db98ea16b18fb901be05cfb41d.svg";
export { ForwardRef as ReactComponent };